module.exports = __webpack_public_path__ + "static/img/40020 (5).17c29c0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40020 (5).webp
// module id = d8qv
// module chunks = 14